import React, { Component } from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav, NavItem} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'
import  Sidebar from "./Sidebar";
import Fade from 'react-reveal/Fade';




class Usine extends Component {
  render() {
    return (
    <div>   
  <section className="inner-intro bg-image overlay-dark  parallax parallax-background1 inner_page_background" style={{backgroundImage:'url("/assets/img/images/facade.png")'}}>
            <div className="container">
                <div className="row title">
                    <h2 className="h2">Green Agro Business</h2>
                    <div className="page-breadcrumb">
                        <a>Green Agro Business</a>/<span>Notre Usine</span>
                    </div>
                </div>
            </div>
        </section>
    <section id="about" className="wow fadeIn ptb ptb-sm-80">
           <div className="container filigrane page_info">
          

            <div className="row inside_content">

           <div className="col-md-8">
                <h3><img src="/assets/img/leaf.png" className="leaf-sidebar"/>  Notre Usine</h3> 
                <div className="content">
                <Fade left>
                <div className="row">

                    <div className="col-md-12">
                   <p>D’une capacité de production pouvant atteindre les 70 000 T/an, notre usine dispose d’une :</p>

                        <div className="boxshadows">
                        <i className="fa fa-check-circle"></i><span className="alignation"><h4>charpente, structure métallique</h4></span>
                        <i className="fa fa-check-circle"></i><span className="alignation"><h4>Unité́ de réception matières premières </h4></span>
                        </div>
                         
                    </div> 
                 </div> 
                </Fade>
                <Fade left>
                <div className="row">
                    <div className="col-md-12">
                        <div className="boxshadows">
                        <i className="fa fa-check-circle"></i><span className="alignation"><h4>Unité́ de tamisage et broyage </h4></span>
                        <i className="fa fa-check-circle"></i><span className="alignation"><h4>Unité́ de Granulation </h4></span>
                        </div>
                       
                    </div>  
                </div>
                </Fade>

                <Fade left>
                     <div className="row">
                    <div className="col-md-12">
                        <div className="boxshadows">
                        <i className="fa fa-check-circle"></i><span className="alignation"><h4>Unité́ de stockage et expédition vrac </h4></span>
                        <i className="fa fa-check-circle"></i><span className="alignation"><h4>Unité́ de conditionnement sacs </h4></span>
                        </div>
                       
                    </div> 
                    </div>
                 </Fade>
                 
                </div>                       
                        
                </div>
                <Sidebar/> 
                </div>

           
                </div>
         
        </section>
<hr />

    </div>
       
        

    )
  }
}
export default Usine;


// WEBPACK FOOTER //
// ./src/components/usine.jsx